import { DEFAULT_POSITION_ID, PositionID } from '../../../../common/Positions/Constants';
import { StandardPurpose } from './Standard';
import { FinancialAdvisorPurpose } from './FinancialAdvisor';

export const PURPOSE_PREFACE_MAP: Record<PositionID, string> = {
  [PositionID.STANDARD]: StandardPurpose,
  [PositionID.FINANCIAL_ADVISOR]: FinancialAdvisorPurpose,
};

export const getPurposePreface = (positionId: PositionID) =>
  PURPOSE_PREFACE_MAP[positionId in PositionID ? positionId : DEFAULT_POSITION_ID];
